/* global define */
define('transfercontroller', ['jquery', 'bootstrap_slider', 'Cookie'], function($, slider) {
  return class rt_transfercontroller {
    constructor() {
      this.enableTooltip = 'Enable/disable realtime decimation';
      this.serverData = '';
      this.currslidervalue = 0;
		}
		initAcrossSlider(){
      $('#across_slider').slider({
        ticks: [1, 100, 200, 300, 400],
        ticks_labels: ['1', '100', '200', '300', '400']
      });
      $('#across_slider').slider('setValue',0);
      
      var self = this;
      self.silderFunc('#across_slider', '/transfercontroller/across/value', self);

      $('input[id=across_enabled]').on('change', function(){
        self.connectSelectAndSlider('across_slider', this, self);
      });

      $('#lbl_across').prop('title','Set width across in num. beams. Outer-beams will allways be shown to get coverage');
    }

    initAlongSlider(){
      $('#along_slider').slider({
       ticks: [1, 30, 60, 120],
		ticks_positions: [1,30,60,100],
		formatter: function(value) {
			if (value>120)
				return (value-120) + ' hours';
			else if (value>60)
				return (value-60) + ' minutes';
			return value + ' seconds';
		},
		ticks_tooltip: true,
        ticks_labels: ['1s', '30s', '60s', '60m']
      });

      $('#along_slider').slider('setValue',0);
      
      var self = this;
      self.silderFunc('#along_slider', '/transfercontroller/along/value', self);

      $('input[id=along_enabled]').on('change', function(){
        self.connectSelectAndSlider('along_slider', this, self);
      });

      $('#lbl_along').prop('title', 'Set realtime depth update to be uploaded in selected interval');
      $('#along_enabled').prop('title', 'Enable/Disable transferring along data');
    }

    initPingSlider(){
      $('#pingdata_slider').slider({
        ticks: [1, 30, 60, 120],
    ticks_positions: [1,30,60,100],
    formatter: function(value) {
      if (value>120)
        return (value-120) + ' hours';
      else if (value>60)
        return (value-60) + ' minutes';
      return value + ' seconds';
    },
    ticks_tooltip: true,
        ticks_labels: ['1s', '30s', '60s', '60m']
      });

      $('#pingdata_slider').slider('setValue',0);
      
      var self = this;
      self.silderFunc('#pingdata_slider', '/transfercontroller/pingdata/value', self);

      $('input[id=pingdata_enabled]').on('change', function(){
        self.connectSelectAndSlider('pingdata_slider', this, self);
      });

      $('#lbl_pingdata').prop('title', 'Set to upload pingdisplay data in selected interval');
      $('#pingdata_enabled').prop('title', 'Enable/Disable transferring ping display data');
    }

    initNumdispSlider(){
      $('#numdisp_slider').slider({
        ticks: [1, 30, 60, 120],
    ticks_positions: [1,30,60,100],
    formatter: function(value) {
      if (value>120)
        return (value-120) + ' hours';
      else if (value>60)
        return (value-60) + ' minutes';
      return value + ' seconds';
    },
    ticks_tooltip: true,
        ticks_labels: ['1s', '30s', '60s', '60m']
      });

      $('#numdisp_slider').slider('setValue',0);
      
      var self = this;
      self.silderFunc('#numdisp_slider', '/transfercontroller/numdisp/value', self);

      $('input[id=numdisp_enabled]').on('change', function(){
        self.connectSelectAndSlider('numdisp_slider', this, self);
      });

      $('#lbl_numdisp').prop('title', 'Set to upload numdisp data in selected interval');
      $('#numdisp_enabled').prop('title', 'Enable/Disable transferring numdisp data');
    }

    // initNumdispSlider(){
    //   $('#numdisp_slider').slider({
    //     ticks: [0, 60, 120, 144],
    // ticks_positions: [0,30,60,100],
    // formatter: function(value) {
    //   if (value>120)
    //     return (value-120) + ' hours';
    //   else if (value>60)
    //     return (value-60) + ' minutes';
    //   return value + ' seconds';
    // },
    // ticks_tooltip: true,
    //     ticks_labels: ['Disable', '60s', '60m', '24h']
    //   });

    //   $('#numdisp_slider').slider('setValue',0);
      
    //   var self = this;
    //   self.silderFunc('#numdisp_slider', '/transfercontroller/numdisp/value', self);

    //   $('input[id=numdisp_enabled]').on('change', function(){
    //     self.connectSelectAndSlider('numdisp_slider', this, self);
    //   });

    //   $('#lbl_numdisp').prop('title', 'Set to upload numerical display data in selected interval');
    //   $('#numdisp_enabled').prop('title', 'Enable/Disable transferring numerical data');
    // }

    // initSideScanSlider(){
    //   $('#sidescan_slider').slider({
    //     ticks: [0, 60, 120, 144],
    // ticks_positions: [0,30,60,100],
    // formatter: function(value) {
    //   if (value>120)
    //     return (value-120) + ' hours';
    //   else if (value>60)
    //     return (value-60) + ' minutes';
    //   return value + ' seconds';
    // },
    // ticks_tooltip: true,
    //     ticks_labels: ['Disable', '60s', '60m', '24h']
    //   });

    //   $('#sidescan_slider').slider('setValue',0);
      
    //   var self = this;
    //   self.silderFunc('#sidescan_slider', '/transfercontroller/sidescan/value', self);

    //   $('input[id=sidescan_enabled]').on('change', function(){
    //     self.connectSelectAndSlider('sidescan_slider', this, self);
    //   });

    //   $('#lbl_sidescan').prop('title', 'Set to upload side scan data in selected interval');
    //   $('#sidescan_enabled').prop('title', 'Enable/Disable transferring side scan data');
    // }

    initPosSlider(){
      $('#pos_slider').slider({
        ticks: [1, 30, 60, 120],
		ticks_positions: [1,30,60,100],
		formatter: function(value) {
			if (value>120)
				return (value-120) + ' hours';
			else if (value>60)
				return (value-60) + ' minutes';
			return value + ' seconds';
		},
		ticks_tooltip: true,
        ticks_labels: ['1s', '30s', '60s', '60m']
      });

      $('#pos_slider').slider('setValue',0);
      
      var self = this;
      self.silderFunc('#pos_slider', '/transfercontroller/pos/value', self);

      $('input[id=pos_enabled]').on('change', function(){
        self.connectSelectAndSlider('pos_slider', this, self);
      });

      $('#lbl_pos').prop('title', 'Set realtime position update to be uploaded in selected interval');
      $('#pos_enabled').prop('title', 'Enable/Disable transferring position data');
    }

    initRtDepthUploader(){
      $('#rtstatus_slider').slider({
        ticks: [1, 60, 120, 144],
		ticks_positions: [1,30,60,100],
		formatter: function(value) {
			if (value>120)
				return (value-120) + ' hours';
			else if (value>60)
				return (value-60) + ' minutes';
			return value + ' seconds';
		},
		ticks_tooltip: true,
        ticks_labels: ['1s', '60s', '60m', '24h']
      });

      $('#rtstatus_slider').slider('setValue',1);
      
      var self = this;
      self.silderFunc('#rtstatus_slider', '/transfercontroller/rtstatus/value', self);

      $('input[id=rtdepth_enabled]').on('change', function(){
        self.connectSelectAndSlider('rtstatus_slider', this, self);
      });
      $("#rtdepth_enabled").val("1");
      $('#rtdepth_enabled').trigger('change');

      $('#lbl_rtdepth').prop('title','Set realtime communication to Remote Operator to be uploaded in selected interval');
      $('#rtdepth_enabled').prop('title', 'Enable/Disable transferring status information to remote operator');
    }

    initTerrainUploader(){
      $('#terrain_slider').slider({
        ticks: [60, 120, 144],
		formatter: function(value) {
			if (value>120)
				return (value-120) + ' hours';
			else if (value>60)
				return (value-60) + ' minutes';
			return value + ' seconds';
		},
		ticks_tooltip: true,
        ticks_labels: ['60s', '60m', '24h']
      });

      $('#terrain_slider').slider('setValue',0);
     
      var self = this;
      self.silderFunc('#terrain_slider', '/transfercontroller/terrain/value', self);

      $('input[id=terrain_enabled]').on('change', function(){
        self.connectSelectAndSlider('terrain_slider', this, self);
      });

      $('#lbl_terrain').prop('title', 'Terrain will be uploaded in selected interval');
      $('#terrain_enabled').prop('title', 'Enable/Disable uploading gridded terrain');
    }

    initKognifaiUploaders(){
      var self = this;
      $('#kmall_enabled').click(function() {
        if(this.checked) {
          self.postServer('/transfercontroller/kmall/enabled', '');
        }
        else {
          self.postServer('/transfercontroller/kmall/disabled', '');
        }
      });

      $('#kmall_enabled').prop('title', this.enableTooltip);
      $('#lbl_kmall').prop('title', 'Kmall-rawfiles will be uploaded to KognifAi storage');

      $('#kmwcd_enabled').click(function() {
        if(this.checked) {
          self.postServer('/transfercontroller/kmwcd/enabled', '');
        }
        else {
          self.postServer('/transfercontroller/kmwcd/disabled', '');
        }
      });

      $('#kmwcd_enabled').prop('title', this.enableTooltip);
      $('#lbl_kmwcd').prop('title', 'Kmwcd-rawfiles will be uploaded to KognifAi storage');
    }

    initKillSwitch(){
      var self = this;
      $('#kill_switch').change(function() {
        if(this.checked) {
          self.postServer('/transfercontroller/killswitch/enabled', '');
        }
        else {
          self.postServer('/transfercontroller/killswitch/disabled', '');
        }
      });

      $('#kill_switch').prop('title', this.enableTooltip);
      $('#lbl_killswitch').prop('title', 'Disable all network communication');
    }

    connectSelectAndSlider(sliderid, select, scope){
      var sliderVal = 0;
      if(!select.checked) {
        $('#'+sliderid).slider('disable');
        //$('#'+sliderid).slider('setValue',0);
      }
      else {
        $('#'+sliderid).slider('enable');
        sliderVal = $('#'+sliderid).slider('getValue');
      }
      var uriroute = sliderid.replace('_slider', '');
      var val = 'val='+sliderVal;
      console.log(sliderid + " : " + uriroute + " : " + val);
      scope.postServer('/transfercontroller/'+uriroute+'/value', val);
    }

    silderFunc(sliderid, posturi, scope){
      $(sliderid).on('slide', function(sliderVal) {
        scope.currslidervalue = sliderVal.value;
      });
      $(sliderid).on('slideStop', function(sliderVal) {
        var test = sliderVal.value;
        if(test === undefined) {
          $(sliderid).slider('setValue',scope.currslidervalue);
        }
        console.log(sliderid + " : " + posturi + " : " + scope.currslidervalue);
        scope.postServer(posturi, 'val='+scope.currslidervalue);
      });
    }

    updateFields(){
      var self = this;
      $.post('/transfercontroller/getstatus', function (data) {
        self.getServerData(data);

        var bms = parseInt(self.serverData.beams);

        if(self.serverData.across === '0'){ // 100 is off in this case, due to value is % of beams
          $('#across_enabled').prop('checked', false);
        } else {
		  //Update ticks
                  
          var stp = bms/4;		  
		  var b1 = bms/2;
		  
		  
		  var newTics = [1, stp, stp*2, stp*3, bms];
		  var newLbls = ['1', stp.toString(), (stp*2).toString(), (stp*3).toString(), bms.toString()];
		  
		  $('#across_slider').slider('setAttribute', 'max', bms); 
          $('#across_slider').slider('setAttribute', 'ticks_labels', newLbls);
          $('#across_slider').slider('setAttribute', 'ticks', newTics);
          $('#across_slider').slider('refresh');	
			
          $('#across_enabled').prop('checked', true);
          var val = parseInt(self.serverData.across);
          $('#across_slider').slider('setValue',val);

          
           
        }
        $('#across_enabled').trigger('change');

        if(self.serverData.along === '0'){          
          
          $('#along_enabled').prop('checked', false);
        } else {
          $('#along_enabled').prop('checked', true);          

          var val = parseInt(self.serverData.along);
        
          $('#along_slider').slider('setValue',val);
        }
        $('#along_enabled').trigger('change');

        if(self.serverData.pos === '0'){
          $('#pos_enabled').prop('checked', false);
        } else {
          $('#pos_enabled').prop('checked', true);
          var val = parseInt(self.serverData.pos);
          $('#pos_slider').slider('setValue',val);
        }
        $('#pos_enabled').trigger('change');

        if(self.serverData.rtstatus === '0'){
          $('#rtdepth_enabled').prop('checked', false);
        } else {
          $('#rtdepth_enabled').prop('checked', true);
          var val = parseInt(self.serverData.rtstatus);
          $('#rtstatus_slider').slider('setValue',val);
        }
        $('#rtdepth_enabled').trigger('change');

        if(self.serverData.terrain === '0'){
          $('#terrain_enabled').prop('checked', false);
        } else {
          $('#terrain_enabled').prop('checked', true);
          var val = parseInt(self.serverData.terrain);
          $('#terrain_slider').slider('setValue',val);
        }
        $('#terrain_enabled').trigger('change');

        if(self.serverData.pingdisp === '0'){
          $('#pingdata_enabled').prop('checked', false);
        } else {
          $('#pingdata_enabled').prop('checked', true);
          var val = parseInt(self.serverData.pingdisp);
          $('#pingdata_slider').slider('setValue',val);
        }
        $('#pingdata_enabled').trigger('change');

        if(self.serverData.numdisp === '0'){
          $('#numdisp_enabled').prop('checked', false);
        } else {
          $('#numdisp_enabled').prop('checked', true);
          var val = parseInt(self.serverData.pingdisp);
          $('#numdisp_slider').slider('setValue',val);
        }
        $('#numdisp_enabled').trigger('change');

       

        // if(self.serverData.sidescan === '0'){
        //   $('#sidescan_enabled').val('0');
        // } else {
        //   $('#sidescan_enabled').val('1');
        //   var val = parseInt(self.serverData.sidescan);
        //   $('#sidescan_slider').slider('setValue',val);
        // }
        // $('#sidescan_enabled').trigger('change');

        // if(self.serverData.kmall === '1'){
        //   $('#kmall_enabled').prop('checked', false);
        // } else {
        //   $('#kmall_enabled').prop('checked', true);
        // }
        // $('#kmall_enabled').trigger('click');

        // if(self.serverData.kmwcd === '1'){
        //   $('#kmwcd_enabled').prop('checked', false);
        // } else {
        //   $('#kmwcd_enabled').prop('checked', true);
        // }
        // $('#kmwcd_enabled').trigger('click');

        if(self.serverData.killswitch === '0'){
          $('#kill_switch').prop('checked', false);
        } else {
          $('#kill_switch').prop('checked', true);
        }
        $('#kill_switch').trigger('click');
      }).fail(function (error, status) {
        //alert('Error: ' + status);
      });
    }
    postServer(url, val){
      $.post(url, val, function (data) {
        // Success
      }).fail(function (error, status) {
        //alert('Error: ' + status);
      });
    }
    getServerData(data){
      if (typeof data === 'string') {
        this.serverData = $.parseJSON(data);
        //alert(this.serverData.status === 'on');
		console.log(this.serverData);
      }
    }
  }
});
